/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2023 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2023-07-11
 *
 * ---------------------------------------------------------------------------
 */

import { login } from '../../settings/settings';
import Login from '../../scenes/Login';
import SSO from '../../scenes/SSO';
import LoginMsal from '../../scenes/MSAL/LoginMsal';
import OIDC from '../../scenes/OIDC';

export function getLoginRoute() {
  const loginRoute = {
    path: login.loginPageUrl,
    completePath: login.loginPageUrl,
    component: Login
  };
  switch (login.authType) {
    case 'SSO': {
      loginRoute.path = login.ssoPageUrl;
      loginRoute.completePath = login.ssoPageUrl;
      loginRoute.component = SSO;
      break;
    }
    case 'MSAL': {
      loginRoute.path = login.msalPageUrl;
      loginRoute.completePath = login.msalPageUrl;
      loginRoute.component = LoginMsal;
      break;
    }
    case 'OIDC': {
      loginRoute.path = login.loginPageUrl;
      loginRoute.completePath = login.loginPageUrl;
      loginRoute.component = OIDC;
      break;
    }
    default:
      break;
  }
  return loginRoute;
}
